import { AnalyticsStore, codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { PageData } from 'bernie-http';
import '../client/temp-common-imports';

import { ProgramStore, PzCampaignStore, UiStore } from 'stores';

// util
import analyticsUtil from '../util/AnalyticsUtil';
import { pageNames } from '../data/page-names';

export class JoinProgramController implements Controller {
  public pageId = pageNames.joinProgram;
  public path = '/:localeName/join-program';
  public routeName = 'join-program';
  public bundles = [];

  public component = codeSplit(() => import(/* webpackChunkName: "join-program-page" */ '../views/join-program-page'));

  public exact = true;

  // tslint:disable-next-line:prefer-function-over-method
  public async fetch(options: FetchOptions): Promise<Result> {
    const { stores, request, query } = options;

    const context = request.context;

    const analyticsStore: AnalyticsStore = stores && stores.get<AnalyticsStore>('analytics');

    const uiStore = stores?.get<UiStore>('uiStore');
    uiStore?.setPageName(this.pageId);

    analyticsUtil.runAnalytics(this.pageId, analyticsStore, context);

    return Promise.resolve(Result.ok());
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'Partnerize Signup' }) as Promise<PageData>;
  }
}
